import { createContext } from "react";

const BookStoreContext = createContext();

export default BookStoreContext;